import {
  CLEAR_STAGED_UPDATES,
  FAIL_TEAM_IMAGE_UPDATE,
  FAIL_USER_IMAGE_UPDATE,
  RECEIVE_TEAM_IMAGE_UPDATED,
  REQUEST_TEAM_IMAGE_UPDATE,
  STAGE_UPDATE,
  TEMP_BANNER_IMAGE_UPLOADED,
  RECEIVE_USER_IMAGE_UPDATED,
  REQUEST_USER_IMAGE_UPDATE,
} from 'common/actions';
import * as EditTypes from 'common/edit-types';

const defaultState = {
  tempValue: '',
  requesting: false,
  error: null,
};

function bannerImage(state = {}, action) {
  const newState = $.extend(true, {}, defaultState, state);
  switch (action.type) {
  case CLEAR_STAGED_UPDATES:
    newState.value = newState.savedValue;
    newState.saveSuccess = false;
    newState.saveError = false;
    newState.tempValue = '';
    newState.tempImageId = undefined;
    newState.error = null;
    break;
  case STAGE_UPDATE:
    const edit = action.payload;
    if (edit.type !== EditTypes.BANNER_IMAGE) {
      return state;
    }

    newState.value = edit.args.croppedDataUrl;
    newState.saveSuccess = false;
    newState.saveError = false;
    break;
  case TEMP_BANNER_IMAGE_UPLOADED:
    newState.tempValue = action.payload.imageSrc;
    newState.tempImageId = action.payload.imageId;
    break;
  case REQUEST_TEAM_IMAGE_UPDATE:
  case REQUEST_USER_IMAGE_UPDATE:
    if (action.payload.imageType !== 'TEAM_PHOTO' && action.payload.imageType !== 'USER_BANNER') {
      return state;
    }
    newState.requesting = true;
    newState.error = null;
    break;
  case RECEIVE_TEAM_IMAGE_UPDATED:
  case RECEIVE_USER_IMAGE_UPDATED:
    if (action.payload.imageType !== 'TEAM_PHOTO' && action.payload.imageType !== 'USER_BANNER') {
      return state;
    }
    newState.requesting = false;
    newState.error = null;
    newState.value = action.payload.newImageSource;
    newState.savedValue = action.payload.newImageSource;
    break;
  case FAIL_TEAM_IMAGE_UPDATE:
  case FAIL_USER_IMAGE_UPDATE:
    if (action.payload.args.imageType !== 'TEAM_PHOTO' && action.payload.args.imageType !== 'USER_BANNER') {
      return state;
    }
    newState.requesting = false;
    newState.error = action.payload;
    break;
  default:
    return state;
  }

  return newState;
}

export default bannerImage;
